import React, { ChangeEvent, ReactNode, useEffect, useState } from 'react';
import { FormGroup } from '@tencent/spaui';
import Tooltip from 'components/tooltip';

interface FieldProps {
  tag?: 'input' | 'textarea';
  defaultValue?: string;
  label: string;
  tooltip?: string;
  required?: boolean;
  regex?: RegExp;
  disabled?: boolean;
  extra?: ReactNode;
  onChange?: (value: string) => void;
}

const useField = (props: FieldProps) => {
  const { tag, defaultValue, label, tooltip, required, regex, disabled, extra, onChange } = props;

  const [value, setValue] = useState<string>();
  const [error, setError] = useState<string>();

  useEffect(() => setValue(defaultValue), [defaultValue]);

  const Input = tag || 'input';

  const element = (
    <FormGroup status={error ? 'error' : 'normal'} error={error}>
      <label>
        {label}
        {required && <span className="required">*</span>}
        {tooltip && <Tooltip popover={tooltip} />}
      </label>
      <Input
        value={value || ''}
        required={required}
        disabled={disabled}
        onFocus={() => setError('')}
        onChange={(e: ChangeEvent<HTMLInputElement & HTMLTextAreaElement>) => {
          setValue(e.target.value);
          onChange?.(e.target.value);
        }}
        onBlur={() => {
          if (required && !value) {
            setError(`${label}不能为空`);
            return;
          }
          if (!regex) {
            return;
          }
          if (tag !== 'textarea') {
            setError(regex.test(value) ? '' : `请输入正确的${label}`);
            return;
          }

          const valueList = value.split('\n').map((line) => line.trim());
          const errLines = valueList
            .map((line, index) => (!line || regex.test(line.trim()) ? 0 : index + 1))
            .filter((item) => !!item)
            .join('、');
          setValue(valueList.join('\n'));
          setError(errLines ? `第${errLines}行错误` : '');
        }}
      />
      {extra}
    </FormGroup>
  );

  return { value, error, element };
};

export default useField;
